import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'

type Props = {
  assignments: {
    id: string
    workflow_status_id: string
  }[]
  companyId: string
}

export function useBulkUpdateOrderStatus() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ assignments, companyId }: Props) => {
      const response = await axios.put(`assignments/workflow-status`, {
        assignments,
        company_id: companyId,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['workflow-log'])
    },
  })
}
